import React, { VFC } from "react";
import AmpHelpfulButton, {
  generateAmpHelpfulButtonScriptString,
} from "~/components/modules/qaActions/AmpHelpfulButton";
import { QuestionAnswer } from "~/models/questionAnswer";

interface AmpHelpfulButtonWithScriptProps {
  buttonSize?: "small" | "medium";
  helpfulCount?: number;
  increaseFeedbackHelpfulUrl: string;
  questionAnswerId: QuestionAnswer["id"];
}

const scriptId = "amp-helpful-button-script";

const AmpHelpfulButtonWithScript: VFC<AmpHelpfulButtonWithScriptProps> = ({
  buttonSize = "small",
  helpfulCount,
  increaseFeedbackHelpfulUrl,
  questionAnswerId,
}) => {
  return (
    // add 2px to layout size to keep the button shadow on the right
    <amp-script script={scriptId} layout="fixed" width={50} height={66}>
      <AmpHelpfulButton helpfulCount={helpfulCount} size={buttonSize} />
      <div
        dangerouslySetInnerHTML={{
          __html: `
        <script id="${scriptId}" type="text/plain" target="amp-script">
            (() => {
                ${generateAmpHelpfulButtonScriptString({
                  helpfulCount,
                  increaseFeedbackHelpfulUrl,
                  questionAnswerId,
                })}

                updateHelpfulButton(initialHasIncreased);
            })();
        </script>      
      `,
        }}
      />
    </amp-script>
  );
};

export default AmpHelpfulButtonWithScript;
